// Legacy web components
import './alert';
import './collapsible-section/inline-collapsible-section';
import './icon/icon';
import './lesson-content-item/lesson-content-item';
import './loading-spinner/loading-spinner';
import './video/brightcove-embed';
import './video/jwplayer-embed';
import './video/kaltura-embed';
import './video/kollective-embed';
import './video/video';
import './video/vidyard-embed';
import './video/vimeo-embed';
import './video/wistia-embed';
import './video/youtube-embed';
import './video/synthesia-embed';

// Import Tippy.js CSS
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/svg-arrow.css';
import 'tippy.js/animations/scale.css';

// Gooey, Vue-filled components
import 'vite/modulepreload-polyfill';
import { defineCustomElement } from 'vue';

import Tile from './catalog-tile/CatalogTile.ce.vue';
import ContextProvider from './context-provider/ContextProvider.ce.vue';
import CatalogTilePlatformWrapper from './catalog-tile-platform-wrapper/CatalogTilePlatformWrapper.ce.vue';
import ViltTimezoneCopy from './vilt/ViltTimezoneCopy.ce.vue';
import ViltMonthDayWidgetCopy from './vilt/ViltMonthDayWidgetCopy.ce.vue';
import SaveContentToggle from './save-content-toggle/SaveContentToggle.ce.vue';
import RemoveSavedContentLink from './remove-saved-content-link/RemoveSavedContentLink.ce.vue';
import Tooltip from './tooltip/Tooltip.ce.vue';
import FederatedSearchPlatformWrapper from './federated-search/FederatedSearchPlatformWrapper.vue';

customElements.define('sjwc-context-provider', defineCustomElement(ContextProvider));
customElements.define('sjwc-catalog-tile', defineCustomElement(Tile));
customElements.define('sjwc-catalog-tile-platform-wrapper', defineCustomElement(CatalogTilePlatformWrapper));
customElements.define('sjwc-federated-search-platform-wrapper', defineCustomElement(FederatedSearchPlatformWrapper));
customElements.define('sjwc-vilt-timezone-copy', defineCustomElement(ViltTimezoneCopy, { shadowRoot: false }));
customElements.define(
  'sjwc-vilt-month-day-widget-copy',
  defineCustomElement(ViltMonthDayWidgetCopy, { shadowRoot: false })
);
customElements.define('sjwc-save-content-toggle', defineCustomElement(SaveContentToggle, { shadowRoot: false }));
customElements.define(
  'sjwc-remove-saved-content-link',
  defineCustomElement(RemoveSavedContentLink, { shadowRoot: false })
);
customElements.define('sjwc-tooltip', defineCustomElement(Tooltip, { shadowRoot: false }));
